/**
 * @generated SignedSource<<a2c9a03922dfad2ed16bb8237ce54754>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type RepositoryNameChipNew_repository$data = {
  readonly name: string;
  readonly owner: string;
  readonly " $fragmentType": "RepositoryNameChipNew_repository";
};
export type RepositoryNameChipNew_repository$key = {
  readonly " $data"?: RepositoryNameChipNew_repository$data;
  readonly " $fragmentSpreads": FragmentRefs<"RepositoryNameChipNew_repository">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "RepositoryNameChipNew_repository",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "owner",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    }
  ],
  "type": "Repository",
  "abstractKey": null
};

(node as any).hash = "83c6cb533931cc3db851ab42b7fc5452";

export default node;
